import { makeStyles } from '@material-ui/core'

import { getDirection } from '../../../localization'

const useStyles = makeStyles((theme) => ({
  topBar: {
    height: 48,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 16,
    paddingRight: 16,
    boxShadow: 'none',
    zIndex: 2,
    backgroundColor: `${theme.palette.background.default} !important`,
    borderRadius: 0,
    borderBottom: `1px solid ${theme.palette.grey[400]}`,
    [theme.breakpoints.down('xs')]: { paddingLeft: 20, flexWrap: 'wrap' },
    justifyContent: 'space-between'
  },
  label: {
    [theme.breakpoints.down('sm')]: { fontSize: 14 }
  },
  LastLabel: {
    color: theme.palette.text.disabled,
    [theme.breakpoints.down('sm')]: { fontSize: 14 }
  },
  skeleton: { width: 110, margin: '0 8px' },
  backIcon: {
    transform: `rotate(${getDirection() === 'rtl' ? '180deg' : '0deg'})`
  },
  boxShadow: {
    boxShadow: '0 0 5px 0 rgb(0 0 0 / 30%)',
    borderWidth: 0
  },
  link: {
    fontSize: 23,
    fontWeight: 600,
    color: theme.palette.text.primary,
    textDecoration: 'none'
  },
  up: {
    display: 'flex',
    flexDirection: 'row'
  },
  mainBreadCrums: {
    display: 'flex'
  },
  mainTime: {
    color: theme.palette.grey[700],
    fontSize: '14px',
    marginRight: getDirection() === 'ltr' ? '87px' : '73px'
  },
  mainOneMinutes: {
    color: theme.palette.primary.main,
    animation: '$blink 1s infinite'
  },

  '@keyframes blink': {
    '0%': { color: theme.palette.error.light },
    '50%': { color: theme.palette.primary.main },
    '100%': { color: theme.palette.error.light }
  },
  mainBalance: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  containerBalance: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  containerLimit: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  textLimit: {
    fontSize: '0.8rem',
    fontWeight: 600
  },
  priceLimit: {
    fontSize: '0.9rem',
    fontWeight: 700
  }
}))

export default useStyles
